/** Firm that owns a case for project assignment (vendor assignments take precedence). */
export function getCaseOwningFirmId(caseData: any): number | undefined {
  if (caseData?.client_assignment?.client_firm_id) {
    return Number(caseData.client_assignment.client_firm_id);
  }
  if (caseData?.vendor_assignment?.vendor_firm_id) {
    return Number(caseData.vendor_assignment.vendor_firm_id);
  }
  if (caseData?.project?.firm_id) {
    return Number(caseData.project.firm_id);
  }
  return undefined;
}
